import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const f: any = function (...args: any[]) {
    f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args);
  };
  f.push = f;
  f.loaded = true;
  f.version = '2.0';
  f.queue = [];
  window.fbq = f;
  window._fbq = f;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', '1641363323529402');
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <SalesPage data-id="element-0" />;
}